module.exports = __webpack_public_path__ + "static/img/17059D_1_R_20201120_fit.939c467.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17059D_1_R_20201120_fit.png
// module id = z+h0
// module chunks = 0